
import Vue from 'vue'
import DataPolicy from '@/views/DataPolicy.vue'
import QuotePanels from '@/views/QuotePanels.vue'

export default Vue.extend({
  name: 'App',

  components: {
    DataPolicy,
    QuotePanels
  },

  data: () => ({
    dataPolicyAccepted: false as boolean
  }),

  computed: {
    component (): string {
      if (!this.dataPolicyAccepted) {
        return 'DataPolicy'
      }

      return 'QuotePanels'
    }
  }
})
